import React, { useRef } from 'react';

import { FileItemSvg } from '@entities/attachment/ui/FileItem/FileItemSvg';
import { ICommentMessage } from '@entities/message/model/types';
import { downloadFile, getNameExtension, isImg } from '@shared/helpers';
import { useIsOverflowing } from '@shared/hooks';
import { Flex, Icon, Image, UiButton, UiText } from '@shared/ui';
import { useCommentsMainContext } from '@widgets/Comments/model';

import cls from './MessageAttachments.module.css';

export const MessageAttachment = ({
    attachment,
    attachments,
}: {
    attachment: ICommentMessage['files'][0];
    attachments: ICommentMessage['files'];
}) => {
    const elNameRef = useRef(null);
    const { isOverflowing } = useIsOverflowing({ elRef: elNameRef });
    const { openAttachmentLightbox } = useCommentsMainContext();
    const isImage = isImg(attachment?.mimeType);

    const downloadAttachment = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        await downloadFile(attachment?.originalUrl, attachment.name);
    };

    return (
        <Flex
            gap={8}
            fullWidth
            className={cls.MessageAttachmentRow}
            onClick={() => openAttachmentLightbox(attachments, attachment.id)}
        >
            <UiButton
                className={cls.UploadAttachmentBtn}
                variant="icon"
                startIcon={
                    <Icon iconName="downloadAttachment" fill="#818998" width={16} height={16} />
                }
                onClick={downloadAttachment}
            />
            {isImage && (
                <Image
                    src={attachment.previewUrl}
                    width={28}
                    height={28}
                    draggable={false}
                    alt={attachment.name}
                    wrapperClassName={cls.MessageAttachmentImgWrapper}
                    className={cls.MessageAttachmentImg}
                />
            )}
            <img src={attachment?.previewSvgUrl} alt={attachment.name} width={28} height={28} />
            {/* <FileItemSvg iconWidth={28} iconHeight={28} extension={nameExtension.extension} /> */}
            <UiText
                ref={elNameRef}
                variant="mediumPlain"
                title={isOverflowing ? attachment.name : ''}
                className={cls.MessageAttachmentName}
            >
                {attachment.name}
            </UiText>
        </Flex>
    );
};
